import store from '../../store/store';
import {vue} from "../../../app";

/**
 * Redirects to the home page if the user is already subscribed
 *
 * @param next
 * @param router
 * @returns {*}
 */
export default function auth({ next, router}) {
    if(store.getters.isSubscribed || store.getters.isAdmin) {
        vue.$snotify.info(vue.$t('middleware.already_subscribed'));
        return router.push({ name: 'home' });
    }

    return next();
}
